export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_REQUEST = "LOGIN_REQUEST";

export const LOGIN_VERIFICATION_SUCCESS = "LOGIN_VERIFICATION_SUCCESS";
export const LOGIN_VERIFICATION_ERROR = "LOGIN_VERIFICATION_ERROR";
export const LOGIN_VERIFICATION_REQUEST = "LOGIN_VERIFICATION_REQUEST";

export const REGISTRATION_SUCCESS = "REGISTRATION_SUCCESS";
export const REGISTRATION_ERROR = "REGISTRATION_ERROR";
export const REGISTRATION_REQUEST = "REGISTRATION_REQUEST";

export const VERIFICATION_SUCCESS = "VERIFICATION_SUCCESS";
export const VERIFICATION_ERROR = "VERIFICATION_ERROR";
export const VERIFICATION_REQUEST = "VERIFICATION_REQUEST";

export const MFA_VERIFY_CODE_SUCCESS = "MFA_VERIFY_CODE_SUCCESS";
export const MFA_VERIFY_CODE_ERROR = "MFA_VERIFY_CODE_ERROR";
export const MFA_VERIFY_CODE_REQUEST = "MFA_VERIFY_CODE_REQUEST";

export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR";
export const FORGET_PASSWORD_REQUEST = "FORGET_PASSWORD_REQUEST";

export const FORGET_VERIFICATION_SUCCESS = "FORGET_VERIFICATION_SUCCESS";
export const FORGET_VERIFICATION_ERROR = "FORGET_VERIFICATION_ERROR";
export const FORGET_VERIFICATION_REQUEST = "FORGET_VERIFICATION_REQUEST";